<template>
  <div class="b-filter__list super-filter" style="margin-bottom: 30px">
    <div
      v-for="(item, key) in filters"
      :key="key"
      class="e-filter"
      style="min-width: 50px"
      :name="item.name"
    >
      <!--     Заголовок фильтра, раскрывающий список       -->
      <input
        type="radio"
        @change="filterRadioChangeHandler(key)"
        name="flabel"
        class="flabel-input"
        :class="{
          'flabel-input--active':
            activeFilters[key] && activeFilters[key].length
        }"
        :id="'flabel-' + key"
      />
      <label
        :for="'flabel-' + key"
        class="flabel-label"
        style="align-items: center"
      >
        {{ item.title
        }}<v-icon size="18" color="#000000">mdi-chevron-down</v-icon>
      </label>
      <!--     Сброс фильтра       -->
      <button
        v-if="activeFilters[key] && activeFilters[key].length"
        type="button"
        @click="reset(key)"
      >
        <v-icon small color="#000000">mdi-close</v-icon>
      </button>
      <!--     Выпадающий список фильтров       -->
      <div class="e-filter__dd elevation-3">
        <label v-for="(value, j) in item.values" :key="j">
          <input
            type="checkbox"
            v-model="activeFilters[key]"
            @change="filterCheckBoxChangeHandler"
            :name="item.name"
            :value="value"
            style="display: inline-block !important"
          />
          {{ value }}
        </label>
      </div>
    </div>
    <!--     Сброс всех фильтров       -->
    <div v-if="isFilter" class="btn-box">
      <button type="reset" @click="resetAll">
        <v-icon small color="#000000">mdi-close</v-icon>
        <span>{{ mess.filter_customers_reset }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import intersectionBy from "lodash/intersectionBy";
import compact from "lodash/compact";

export default {
  name: "CustomersFilter",
  props: {
    data: Array,
    filterFields: Array
  },
  data: () => ({
    activeFilters: {},
    currentFilter: null,
    filtersPrevStep: null,
    filtersReadyToUpdate: true
  }),
  methods: {
    filterRadioChangeHandler(type) {
      this.currentFilter = type;
      this.filtersReadyToUpdate = false;
    },
    filterCheckBoxChangeHandler() {
      this.filtersReadyToUpdate = true;
      this.emmitEventFiltered();
    },
    reset(type) {
      this.filtersReadyToUpdate = true;
      this.$set(this.activeFilters, type, []);
      return this.emmitEventFiltered();
    },
    resetAll() {
      this.filtersReadyToUpdate = true;
      for (let key in this.activeFilters) {
        this.$set(this.activeFilters, key, []);
      }

      return this.emmitEventFiltered();
    },
    emmitEventFiltered() {
      this.$emit("filtered", this.filteredData);
    }
  },
  computed: {
    isFilter() {
      let isFilter = false;

      for (let key in this.activeFilters) {
        if (this.activeFilters[key].length) isFilter = true;
      }

      return isFilter;
    },
    filteredCustomers() {
      const { data, activeFilters, isFilter } = this;

      if (!isFilter) return data;

      let newData = JSON.parse(JSON.stringify(data));

      data.forEach((el, elIndex) => {
        el.items.forEach((item, i) => {
          for (let key in activeFilters) {
            activeFilters[key].length && !activeFilters[key].includes(item[key])
              ? (newData[elIndex].items[i] = null)
              : null;
          }
        });
      });

      newData.forEach((ps, i, arr) => {
        arr[i].items = compact(arr[i].items);
      });

      return newData.filter(el => el.items.length);
    },
    filteredEquipment() {
      let arr = [];

      this.filteredCustomers.forEach(el => {
        el.items.forEach(item => arr.push(item));
      });

      return arr;
    },
    filteredData() {
      return intersectionBy(this.data, this.filteredCustomers, "id");
    },
    filters() {
      if (!this.filtersReadyToUpdate) return this.filtersPrevStep;

      let filters = {};

      this.filterFields.forEach(field => {
        filters[field.val] = { title: field.label, values: [] };
      });

      this.filteredEquipment.forEach(item => {
        for (let key in item) {
          if (this.currentFilter === key)
            filters[key] = this.filtersPrevStep[key];

          if (filters[key] && !filters[key].values.includes(item[key])) {
            filters[key].values.push(item[key]);
          }
        }
      });

      for (let key in filters) {
        filters[key].values.sort();
      }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.filtersPrevStep = filters;
      return filters;
    }
  },
  watch: {
    currentFilter() {
      this.$nextTick(() => {
        for (let key in this.activeFilters) {
          this.activeFilters[key].forEach((filter, i, arr) => {
            const filterNodeElement = this.$el.querySelector(
              `[value="${filter}"]`
            );
            if (!filterNodeElement) arr[i] = null;
          });
        }

        for (let key in this.activeFilters) {
          this.activeFilters[key] = compact(this.activeFilters[key]);
        }
      });
    }
  },
  mounted() {
    let filterKeys = Object.keys(this.filters);

    for (let key of filterKeys) {
      this.$set(this.activeFilters, key, []);
    }

    document.addEventListener("click", function(event) {
      if (
        event.target.classList.contains("e-filter__dd") ||
        event.target.nodeName === "LABEL" ||
        event.target.nodeName === "INPUT"
      )
        return;
      const inputs = Array.from(document.querySelectorAll("[name=flabel]"));
      inputs.forEach(input => (input.checked = false));
    });
  }
};
</script>

<style lang="scss" scoped>
.e-filter {
  margin-right: 36px !important;

  label {
    display: flex;
  }

  button {
    position: absolute;
    right: -34px;
  }
}

.flabel-label {
  line-height: 1;
}

.flabel-input--active ~ label {
  font-weight: 700;
}
</style>
